import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { alertsApi } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

export function useSubscribeAlert(orgPid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pid: string) => alertsApi.subscribe(pid),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.alerts.byOrg(orgPid) });
      toast.success('Subscribed to alert');
    },
    onError: () => toast.error('Failed to subscribe'),
  });
}

export function useUnsubscribeAlert(orgPid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (pid: string) => alertsApi.unsubscribe(pid),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.alerts.byOrg(orgPid) });
      toast.success('Unsubscribed from alert');
    },
    onError: () => toast.error('Failed to unsubscribe'),
  });
}
